import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const PERMISSION_MAP = {
  admin: [
    'manage:all',
    'products:create', 'products:read', 'products:update', 'products:delete',
    'sales:create', 'sales:read', 'sales:void', 'sales:refund',
    'customers:create', 'customers:read', 'customers:update', 'customers:delete',
    'reports:read',
    'settings:read', 'settings:update',
    'users:read', 'users:create', 'users:update', 'users:delete',
    'backups:create', 'backups:read', 'backups:restore', 'backups:delete',
  ],
  manager: [
    'products:create', 'products:read', 'products:update',
    'sales:create', 'sales:read', 'sales:void',
    'customers:create', 'customers:read', 'customers:update',
    'reports:read',
    'settings:read',
    'users:read',
  ],
  staff: [
    'products:read',
    'sales:create', 'sales:read',
    'customers:create', 'customers:read',
  ],
};

const usePermissions = () => {
  const { user } = useSelector((state) => state.auth);

  const permissions = useMemo(() => {
    return PERMISSION_MAP[String(user?.role || '').toLowerCase()] || [];
  }, [user]);

  const can = (permission) => {
    return permissions.includes('manage:all') || permissions.includes(permission);
  };

  const role = String(user?.role || '').toLowerCase();
  const isAdmin = role === 'admin';
  const isStaff = role === 'staff' || role === 'admin';
  const isManager = role === 'manager' || role === 'admin';

  return { can, isAdmin, isStaff, isManager, role, permissions };
};

export default usePermissions;
